/* declare a variable */
* {
  margin: 0pt;
  font: $xp-ref-font-label-label-short;
}

.drag-and-drop-zone {
  padding: 24pt;
  background-color: $xp-ref-color-background-component-medium-emphasis;

  /* Border CSS */
  border: none;
  background-image: repeating-linear-gradient(to right, #ccc 0, #ccc 10px, transparent 10px, transparent 20px),
    repeating-linear-gradient(to bottom, #ccc 0, #ccc 10px, transparent 10px, transparent 20px),
    repeating-linear-gradient(to right, #ccc 0, #ccc 10px, transparent 10px, transparent 20px),
    repeating-linear-gradient(to bottom, #ccc 0, #ccc 10px, transparent 10px, transparent 20px);
  background-position: top, right, bottom, left;
  background-size:
    100% 2px,
    2px 100%,
    100% 2px,
    2px 100%;
  background-repeat: no-repeat;
  border-radius: 1px;

  /* Layout CSS */
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  /* Transition */
  transition: all;
  transition-duration: 150ms;
}

.drag-and-drop-zone > span {
  color: $xp-ref-color-text-forms-label;
  font-size: larger;
  font-weight: 400;
}

.dragzone-hovered-over {
  background-color: $xp-ref-color-state-select;
}

.hidden {
  display: none;
}

.file-previewer {
  background-color: $xp-ref-color-background-surface-medium-emphasis;
  padding: 15pt;
  fill: $xp-ref-color-semantic-interaction;

  /* layout */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-previewer > span {
  color: $xp-ref-color-text-forms-label;
  font-size: medium;
  font-weight: 500;
}

.file-previewer > svg {
  height: 15pt;
  width: 15pt;
  cursor: pointer;
}

.icon {
  height: 20pt;
  width: 20pt;
  fill: $xp-ref-color-semantic-interaction;
}

.title {
  display: flex;
  overflow-wrap: anywhere;
  flex-direction: row;
  align-items: center;
  gap: $xp-ref-spacing-2;
}

.file-name {
  font: $xp-ref-font-label-label-short;
  color: $xp-ref-color-text-forms-label;
}

.close-button {
  height: 20pt;
  width: 20pt;
  color: $xp-ref-color-semantic-interaction;
  cursor: pointer;
}

.error {
  background-color: $xp-ref-color-semantic-critical-low-emphasis;
}

.error-text {
  font: $xp-ref-font-label-label-short;
  color: $xp-ref-color-semantic-critical-definite;
}

.error-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.container {
  display: flex;
  flex-direction: column;
  gap: $xp-ref-spacing-2;
}

.error-icon {
  color: $xp-ref-color-semantic-critical-definite;
}

.error-button {
  color: $xp-ref-color-semantic-on-critical;
  fill: $xp-ref-color-semantic-on-critical;
}

.button-content {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}

.error-text {
  color: $xp-ref-color-semantic-on-critical !important;
}

.instruction-text {
  font: $xp-ref-font-paragraph-paragraph-short;
  color: $xp-ref-color-text-forms-label;
}
